import $ from 'jquery'
window.jQuery = $;
require("@fancyapps/fancybox");

export default {
    install: (Vue) => {
        Vue.prototype.$fancybox = {
            open(parameters) {
                
                const {
                    type,
                    src,
                    gallery,
                    opts
                } = parameters;

                if (gallery) {
                    if (src) {
                        let galleryItem;
                        for (var i = 0; i < gallery.length; i += 1) {
                            if (gallery[i]['src'] === src) {
                                galleryItem = i;
                            }
                        }
                        $.fancybox.open(gallery, opts).jumpTo(galleryItem);
                    } else {
                        $.fancybox.open(gallery, opts)
                    }
                } else {
                    $.fancybox.open({
                        src: src,
                        type: type,
                        opts: opts
                    });
                }
            },
            close() {
                $.fancybox.close();
            }
        };
    }
};


// WEBPACK FOOTER //
// ./src/js/plugins/fancy-box/fancybox.js